// document.addEventListener('DOMContentLoaded', () => {
//   const section = document.querySelector('[js-product-section]');
//   if (!section) return;

//   const bundleColorMap = {
//     '1 Pack': ['Yellow', 'Pink', 'Orange', 'Blue', 'Green'],
//     '2 Pack': ['Green & Yellow', 'Blue & Green', 'Orange & Yellow'],
//     '4 Pack': ['Assorted'],
//     '10 Pack': ['Assorted'],
//   };

//   function filterColors(selectedBundle) {
//     const allowedColors = bundleColorMap[selectedBundle];
//     if (!allowedColors) return;

//     section.querySelectorAll('[js-variant-input][data-variant-layout="swatches"], [js-variant-input][data-variant-layout="chips"]').forEach((input) => {
//       const label = input.closest('label');
//       if (!label) return;
//       const swatchBtn = label.querySelector('[js-swatch], [js-chip]');
//       if (!swatchBtn) return;
//       const colorValue = swatchBtn.getAttribute('data-value');
//       if (!colorValue) return;
//       // Only filter if this is a color option (has a value in our full color list)
//       const allColors = Object.values(bundleColorMap).flat();
//       if (!allColors.includes(colorValue)) return;
//       label.style.display = allowedColors.includes(colorValue) ? '' : 'none';
//     });
//   }

//   // Run on bundle option change
//   section.addEventListener('change', (e) => {
//     const input = e.target;
//     if (!input.matches('[js-variant-input]')) return;
//     const label = input.closest('label');
//     if (!label) return;
//     const chipBtn = label.querySelector('[js-chip]');
//     if (!chipBtn) return;
//     const bundleValue = chipBtn.getAttribute('data-value');
//     if (bundleColorMap[bundleValue] !== undefined) {
//       filterColors(bundleValue);
//     }
//   });

//   // Run on page load with default selected bundle
//   const selectedBundleChip = section.querySelector('[js-chip].chip--selected');
//   if (selectedBundleChip) {
//     filterColors(selectedBundleChip.getAttribute('data-value'));
//   }
// });

/**
 * Pack/bundle: show only valid color swatches and select first in-stock variant on pack change.
 */
(function () {
  const VARIANT_CHANGING = 'product:variant:changing';

  function normalize(value) {
    return String(value ?? '').trim();
  }

  function getProductData(variantSelector) {
    const script = variantSelector?.querySelector('[data-tickmitt-product-variants]');
    if (!script?.textContent) return { options: [], variants: [] };

    try {
      const parsed = JSON.parse(script.textContent);
      if (Array.isArray(parsed)) {
        return { options: [], variants: parsed };
      }
      return {
        options: parsed.options || [],
        variants: parsed.variants || [],
      };
    } catch {
      return { options: [], variants: [] };
    }
  }

  function getOptionIndex(optionNames, optionName) {
    return optionNames.indexOf(optionName);
  }

  function isPackOptionGroup(group) {
    return (
      group?.querySelector('.option-group__chips-container') &&
      !group.querySelector('.option-group__swatches-container')
    );
  }

  function getOptionValueFromLabel(label) {
    if (!label) return null;
    return (
      normalize(label.dataset.optionValue) ||
      normalize(label.querySelector('[js-swatch]')?.getAttribute('data-value')) ||
      normalize(label.querySelector('[js-chip]')?.getAttribute('data-value')) ||
      normalize(label.querySelector('[js-chip]')?.textContent)
    );
  }

  function findFirstAvailableVariantForPack(variants, optionNames, packOptionName, packValue) {
    const packIndex = getOptionIndex(optionNames, packOptionName);
    if (packIndex < 0) return null;
    const normalizedPack = normalize(packValue);

    return variants.find(
      (variant) =>
        variant.available && normalize(variant.options?.[packIndex]) === normalizedPack,
    );
  }

  function getVariantFromInput(variants, input) {
    if (!input?.value) return null;
    return variants.find((v) => v.id === Number(input.value)) || null;
  }

  function getOptionNames(variantSelector, productData) {
    if (productData.options?.length) return productData.options;

    const names = [];
    variantSelector.querySelectorAll('[js-variant-group-container]').forEach((group) => {
      if (group.dataset.optionName) names.push(group.dataset.optionName);
    });
    return names;
  }

  function getActiveVariant(variantSelector, variants) {
    const checked = variantSelector.querySelector('[js-variant-input]:checked');
    let variant = getVariantFromInput(variants, checked);

    if (!variant) {
      const currentId = Number(variantSelector.getAttribute('data-current-variant-id'));
      if (currentId) {
        variant = variants.find((v) => v.id === currentId);
      }
    }

    return variant || null;
  }

  function getSelectedOptions(variant, optionNames) {
    const selected = {};
    if (!variant?.options) return selected;
    variant.options.forEach((value, index) => {
      if (optionNames[index]) {
        selected[optionNames[index]] = value;
      }
    });
    return selected;
  }

  function variantMatchesSelection(
    variant,
    optionNames,
    selectedOptions,
    colorOptionName,
    colorValue,
  ) {
    if (!variant.available || !variant.options?.length) return false;

    return variant.options.every((optionValue, index) => {
      const name = optionNames[index];
      if (!name) return true;
      if (name === colorOptionName) {
        return normalize(optionValue) === normalize(colorValue);
      }
      const selected = selectedOptions[name];
      if (selected) return normalize(optionValue) === normalize(selected);
      return true;
    });
  }

  function syncSelectionUI(variantSelector, variants, optionNames) {
    if (!variantSelector) return;

    variantSelector.querySelectorAll('.swatch--selected').forEach((el) => {
      el.classList.remove('swatch--selected');
    });
    variantSelector.querySelectorAll('.chip--selected').forEach((el) => {
      el.classList.remove('chip--selected');
    });

    const variant = getActiveVariant(variantSelector, variants);
    if (!variant?.options) return;

    variantSelector.querySelectorAll('[js-variant-group-container]').forEach((group) => {
      const optionName = group.dataset.optionName;
      const optionIndex = getOptionIndex(optionNames, optionName);
      if (optionIndex < 0) return;

      const optionValue = normalize(variant.options[optionIndex]);
      const labelValue = group.querySelector('[js-variant-label-value]');
      if (labelValue) {
        labelValue.textContent = ` ${variant.options[optionIndex]}`;
      }

      if (group.querySelector('.option-group__swatches-container')) {
        group.querySelectorAll('.variant-option--swatches').forEach((label) => {
          if (label.hidden) return;
          if (getOptionValueFromLabel(label) === optionValue) {
            label.querySelector('[js-swatch]')?.classList.add('swatch--selected');
          }
        });
      }

      if (isPackOptionGroup(group)) {
        group.querySelectorAll('label').forEach((label) => {
          if (getOptionValueFromLabel(label) === optionValue) {
            label.querySelector('[js-chip]')?.classList.add('chip--selected');
          }
        });
      }
    });
  }

  function filterSwatches(variantSelector, variants, optionNames) {
    if (!variants.length) return;

    const variant = getActiveVariant(variantSelector, variants);
    const selectedOptions = getSelectedOptions(variant, optionNames);

    variantSelector.querySelectorAll('[js-variant-group-container]').forEach((group) => {
      if (!group.querySelector('.option-group__swatches-container')) return;

      const colorOptionName = group.dataset.optionName;
      if (!colorOptionName) return;

      group.querySelectorAll('.variant-option--swatches').forEach((label) => {
        const colorValue = getOptionValueFromLabel(label);
        if (!colorValue) return;

        const show = variants.some((v) =>
          variantMatchesSelection(v, optionNames, selectedOptions, colorOptionName, colorValue),
        );

        label.hidden = !show;
        if (!show) {
          label.querySelector('[js-swatch]')?.classList.remove('swatch--selected');
        }
      });
    });
  }

  function resolvePackSelection(section, packInput) {
    const variantSelector = section.querySelector('product-block-variant-selector');
    if (!variantSelector) return packInput;

    const packGroup = packInput.closest('[js-variant-group-container]');
    if (!isPackOptionGroup(packGroup)) return packInput;

    const productData = getProductData(variantSelector);
    const optionNames = getOptionNames(variantSelector, productData);
    const variants = productData.variants;
    const packOptionName = packGroup.dataset.optionName;
    const packValue = getOptionValueFromLabel(packInput.closest('label'));

    if (!packOptionName || !packValue || !variants.length) return packInput;

    const targetVariant = findFirstAvailableVariantForPack(
      variants,
      optionNames,
      packOptionName,
      packValue,
    );

    if (!targetVariant) return packInput;

    // Swatch radio values are contextual (e.g. 1 Pack + Green), not the full variant id.
    // The theme fetch uses data-variant-id — set it to the real target variant.
    packInput.value = String(targetVariant.id);
    packInput.setAttribute('data-variant-id', String(targetVariant.id));
    packInput.checked = true;

    variantSelector.querySelectorAll('[js-variant-input]').forEach((input) => {
      if (input !== packInput) input.checked = false;
    });

    filterSwatches(variantSelector, variants, optionNames);
    syncSelectionUI(variantSelector, variants, optionNames);

    return packInput;
  }

  function refreshUI(section) {
    const variantSelector = section.querySelector('product-block-variant-selector');
    if (!variantSelector) return;

    const productData = getProductData(variantSelector);
    const optionNames = getOptionNames(variantSelector, productData);
    const variants = productData.variants;

    filterSwatches(variantSelector, variants, optionNames);
    syncSelectionUI(variantSelector, variants, optionNames);
  }

  function dispatchVariantChanging(section, input) {
    const withinQuickView = section.dataset.sectionType === 'quick-view-product';

    section.dispatchEvent(
      new CustomEvent(VARIANT_CHANGING, {
        bubbles: true,
        detail: {
          newOptionInput: input,
          withinQuickView,
        },
      }),
    );
  }

  function bindVariantBlockListener(section) {
    const variantBlock = section.querySelector('product-block-variant-selector');
    if (!variantBlock || variantBlock.hasAttribute('data-tickmitt-bound')) return;

    variantBlock.setAttribute('data-tickmitt-bound', '');
    variantBlock.addEventListener('product:variant:changed', () => {
      requestAnimationFrame(() => refreshUI(section));
      setTimeout(() => refreshUI(section), 100);
    });
  }

  function initSection(section) {
    refreshUI(section);
    bindVariantBlockListener(section);

    const observer = new MutationObserver(() => {
      bindVariantBlockListener(section);
    });
    observer.observe(section, { childList: true, subtree: true });
  }

  document.addEventListener(
    'change',
    (event) => {
      const input = event.target;
      if (!input.matches('[js-variant-input]')) return;

      const section = input.closest('[js-product-section]');
      if (!section) return;

      const packGroup = input.closest('[js-variant-group-container]');
      if (!isPackOptionGroup(packGroup)) {
        requestAnimationFrame(() => refreshUI(section));
        return;
      }

      event.stopImmediatePropagation();

      const resolvedInput = resolvePackSelection(section, input);
      dispatchVariantChanging(section, resolvedInput);
    },
    true,
  );

  function init() {
    document.querySelectorAll('[js-product-section]').forEach(initSection);
    requestAnimationFrame(() => {
      document.querySelectorAll('[js-product-section]').forEach((section) => refreshUI(section));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
